if (!customElements.get('recently-viewed')) {
  customElements.define(
     'recently-viewed',
              class RecentlyViewed extends HTMLElement {
                constructor() {
                  super();
                  this.bindEvents();
                }
              
                    bindEvents(){
                         const main_wapper  = this.querySelector('recentlyviewed-product');
                         const product_hendle = this.getAttribute('data-product-handle');
                         const this_obj = this;
                         const gridItemWidth = this.getAttribute('data-grid-item-class');
                         const rowOf = this.getAttribute('data-row-of');
                         const images_size = this.getAttribute('data-image-sizes');
                         const enable_quick_add = this.getAttribute('data-quick_add_btn');
                        var promises = [];
                          Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
                            if (handle !== 'undefined') {
                               promises.push(getProductInfo(handle));
                            }
                          });

                       Promise.all(promises).then(function(result) {
                        setupOutput(result);
                        // this.captureProductDetails(result);
                      }.bind(this));
                      
                        function getProductInfo (handle){
                              return new Promise(function(resolve, reject) {
                                    if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
                                      resolve(theme.recentlyViewed.productInfo[handle]);
                                    } else {
                                      fetch('/products/'+ handle +'.js').then(function(response) {
                                        return response.text();
                                      }).then(function(product) {
                                        resolve(product);
                                      });
                                    }
                                  });
                            }

                      function setupOutput (products) {
                                  var allProducts = [];
                                  var data = {};
                                  var limit = this_obj.getAttribute('data-recent-count');                            
                                  var i = 0;
                            
                                  Object.keys(products).forEach(function (key) {
                                    if (!products[key]) {
                                      return;
                                    }
                                    var product = JSON.parse(products[key]);
                            
                                    // Ignore current product
                                    if (product.handle === product_hendle) {
                                      return;
                                    }
                            
                                    // Ignore undefined key
                                    if (typeof product.handle == 'undefined') {
                                      return;
                                    }
                            
                                    i++;
                            
                                    // New or formatted properties
                                    const widths = [180, 360, 540, 720, 900];
                                    product.url = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
                                    product.image_responsive_url = buildImagePath(product.featured_image),
                                    product.image_responsive_urls = buildImagePath(product.featured_image, widths);
                            
                                    // Unit pricing checks first variant
                                    var firstVariant = product.variants[0];
                                    if (firstVariant && firstVariant.unit_price) {
                                      var baseUnit = '';
                            
                                      if (firstVariant.unit_price_measurement) {
                                        if (firstVariant.unit_price_measurement.reference_value != 1) {
                                          baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
                                        }
                                        baseUnit += firstVariant.unit_price_measurement.reference_unit;
                                      }
                            
                                      product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
                                      if (baseUnit != '') {
                                        product.unit_price += '/' + baseUnit;
                                      }
                                    }
                            
                                    allProducts.unshift(product);
                                  }.bind(this));
                            
                                  if (allProducts.length === 0) {
                                    this_obj.classList.add('hidden');
                                    return;
                                  }
                            
                                  var productMarkup = theme.buildProductGridItem(allProducts.slice(0, limit), gridItemWidth, rowOf, images_size,enable_quick_add);
                                  this_obj.querySelector('recentlyviewed-product').innerHTML = productMarkup;
                      
                          }

                          function buildImagePath(string, widths) {
                                if (string == null) return [];
                            
                                if (widths) {
                                  const imageUrls = [];
                            
                                  widths.forEach(width => {
                                    let url = `${string}?width=${width}`;
                                    if (width === widths[widths.length - 1]) {
                                      url += ` ${width}w`
                                    } else {
                                      url += ` ${width}w,`
                                    }
                                    imageUrls.push(url);
                                  })
                                  return imageUrls;
                                } else {
                                  return [string];
                                }
                              }
                    }
              }
  );
}

